import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  LinearProgress,
  Chip,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  InputAdornment,
  MenuItem,
  Select,
  Rating,
  FormControl,
  InputLabel,
  Divider,
  Collapse,
  IconButton,
  Tabs,
  Tab,
  Paper,
  Breadcrumbs,
  Link,
  useTheme,
  CardMedia
} from '@mui/material';
// import {
//   HomeWork,
//   DirectionsCar,
//   TwoWheeler,
//   Search,
//   FilterList,
//   Restaurant,
//   Gavel,
//   Home,
//   Event,
//   ColorLens,
//   Add,
//   CheckCircle,
//   LocalOffer,
//   Phone,
//   Email,
//   Schedule,
//   ArrowBack,
//   ArrowForward,
//   LocationOn,
//   Star,
//   People,
//   Work,
//   SupportAgent,
//   Campaign,
//   TwoWheelerOutlined,
//   BuildCircleOutlined,
//    CleanHandsOutlined,
//   LocalOfferOutlined,
//   ApartmentOutlined,
//    CarRentalOutlined,
//   SupportAgentOutlined,
//   EmergencyOutlined,
//   ConstructionOutlined,
//   LocalShippingOutlined,
//   FactoryOutlined,
//    HouseboatOutlined,
//   StarBorderPurple500Outlined,
//    EmojiEmotions,
//   ConstructionRounded,
//   Brush,
//   AutoAwesome,
//   Edit,
//   ReceiptLongOutlined,
//   AccountBalanceWalletRounded,
//   ComputerRounded,
//   FormatBoldTwoTone,
//   FormatListBulletedOutlined,
//   FitnessCenter,
//   NatureOutlined,
//   LocalFlorist,
//   FlashOnOutlined,
//   MedicationLiquidOutlined,
//   HomeRepairService,
//   SettingsApplications,
//   OutlinedFlagSharp,
//   IntegrationInstructionsRounded,
//   BuildSharp,
//   BuildCircleSharp,
//   InterestsSharp,
//   HealthAndSafety,
//   Watch,
//   Kitchen,
//   KitchenRounded,
//   AttachMoney,
//   AttachMoneyOutlined,
//   LocalShippingTwoTone,
//   BuildCircle,
//   EventAvailable,
//   LocalDining,
//   ArchiveRounded,
//   ArchiveOutlined,
//   GavelSharp,
//   Pets,
//   SportsKabaddiOutlined,
//   WifiCalling3,
//   TheaterComedySharp,
//   SecurityUpdateGood,
//   PersonAddAltSharp,
//   Groups,
//   RealEstateAgent,
//   ShieldMoonOutlined,
//   QueuePlayNextRounded,
//   TravelExplore,
//   PestControl,
//   RollerShadesClosedOutlined,
//   PhotoCamera,
//   InfoOutlineRounded,
//   Print,
//   DirectionsCarFilled,
//   ReceiptOutlined,
//   DirectionsCarFilledOutlined,
//   Inventory,
//   AttachMoneySharp,
//   House,
//   LocalOfferRounded,
//   LocalOfferSharp,
//   CampaignOutlined,
//   CleaningServices,
//   ManageAccounts,
//   RecordVoiceOver,
//   ContentCut,
//   HotTub,
//   FaceRetouchingNatural,
//   Palette,
//   Insights,
//   DesignServices,
//   EmojiObjects,
//   Devices,
//   Business,
//   Language,
//   TrendingUp,
//   ContentPaste,
//   Analytics,
//   Favorite,
//   Celebration,
//   ElectricalServices,
//   BusinessCenter,
//   PermMedia,
//   Person,
//   Store,
//   Landscape,
//   Nature,
//   Power,
//   Grass,
//   Agriculture,
//   Water,
//   PhoneInTalk,
//   Accessible,
//   MedicalServices,
//   Science,
//   Psychology,
//   Male,
//   Plumbing,
//   Build,
//   GridOn,
//   FormatPaint,
//   AcUnit,
//   LocalLaundryService,
//   Tv,
//   Computer,
//   Weekend,
//   DeveloperBoard,
//   Settings,
//   Diamond,
//   WaterDamage,
//   SoupKitchen,
//   FamilyRestroom,
//   Description,
//   Handshake,
//   LocalShipping,
//   Storage,
//   AccountBalance,
//   Moving,
//   FlightTakeoff,
//   WorkOutline,
//   EditNote,
//   Translate,
//   ContactSupport,
//   Hotel,
//   DriveEta,
//   PictureAsPdf,
//   Image,
//   OpenInFull,
//   Movie,
//   PhotoCameraFront,
//   PhotoCameraBack,
//   AccountCircle,
//   CameraAlt,
//   PhotoLibrary,
//   BrandingWatermark,
//   Article,
//   Apartment,
//   Construction,
//   Category,
//   Eco,
//   Fastfood,
//   BreakfastDining,
//   BugReport,
//   Bed,
//   ConfirmationNumber,
//   Place,
//   Public,
//   DeliveryDining,
//   School,
//   MenuBook,
//   Smartphone,
//   Router,
//   Satellite,
//   Spa,
//   Videocam,
//   LocalFireDepartment,
//   PersonSearch,
//   Lock,
//   Stars,
//   EventBusy,
//   VolunteerActivism,
//   Checkroom,
//   Memory,
//   Bolt,
//   Calculate,
//   Lightbulb,
//   MonetizationOn,
//   SelfImprovement,
//   Cake,
//   LocalBar,
//   BakeryDining,
//   LocalCafe,
//   HomeFilled,
// } from '@mui/icons-material';
// MUI Icons (individual imports)
import HomeWork from "@mui/icons-material/HomeWork";
import DirectionsCar from "@mui/icons-material/DirectionsCar";
import TwoWheeler from "@mui/icons-material/TwoWheeler";
import Search from "@mui/icons-material/Search";
import FilterList from "@mui/icons-material/FilterList";
import Restaurant from "@mui/icons-material/Restaurant";
import Gavel from "@mui/icons-material/Gavel";
import Home from "@mui/icons-material/Home";
import Event from "@mui/icons-material/Event";
import ColorLens from "@mui/icons-material/ColorLens";
import Add from "@mui/icons-material/Add";
import CheckCircle from "@mui/icons-material/CheckCircle";
import LocalOffer from "@mui/icons-material/LocalOffer";
import Phone from "@mui/icons-material/Phone";
import Email from "@mui/icons-material/Email";
import Schedule from "@mui/icons-material/Schedule";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import LocationOn from "@mui/icons-material/LocationOn";
import Star from "@mui/icons-material/Star";
import People from "@mui/icons-material/People";
import Work from "@mui/icons-material/Work";
import SupportAgent from "@mui/icons-material/SupportAgent";
import Campaign from "@mui/icons-material/Campaign";
import TwoWheelerOutlined from "@mui/icons-material/TwoWheelerOutlined";
import BuildCircleOutlined from "@mui/icons-material/BuildCircleOutlined";
import CleanHandsOutlined from "@mui/icons-material/CleanHandsOutlined";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import ApartmentOutlined from "@mui/icons-material/ApartmentOutlined";
import CarRentalOutlined from "@mui/icons-material/CarRentalOutlined";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import EmergencyOutlined from "@mui/icons-material/EmergencyOutlined";
import ConstructionOutlined from "@mui/icons-material/ConstructionOutlined";
import LocalShippingOutlined from "@mui/icons-material/LocalShippingOutlined";
import FactoryOutlined from "@mui/icons-material/FactoryOutlined";
import HouseboatOutlined from "@mui/icons-material/HouseboatOutlined";
import StarBorderPurple500Outlined from "@mui/icons-material/StarBorderPurple500Outlined";
import EmojiEmotions from "@mui/icons-material/EmojiEmotions";
import ConstructionRounded from "@mui/icons-material/ConstructionRounded";
import Brush from "@mui/icons-material/Brush";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import Edit from "@mui/icons-material/Edit";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import AccountBalanceWalletRounded from "@mui/icons-material/AccountBalanceWalletRounded";
import ComputerRounded from "@mui/icons-material/ComputerRounded";
import FormatBoldTwoTone from "@mui/icons-material/FormatBoldTwoTone";
import FormatListBulletedOutlined from "@mui/icons-material/FormatListBulletedOutlined";
import FitnessCenter from "@mui/icons-material/FitnessCenter";
import NatureOutlined from "@mui/icons-material/NatureOutlined";
import LocalFlorist from "@mui/icons-material/LocalFlorist";
import FlashOnOutlined from "@mui/icons-material/FlashOnOutlined";
import MedicationLiquidOutlined from "@mui/icons-material/MedicationLiquidOutlined";
import HomeRepairService from "@mui/icons-material/HomeRepairService";
import SettingsApplications from "@mui/icons-material/SettingsApplications";
import OutlinedFlagSharp from "@mui/icons-material/OutlinedFlagSharp";
import IntegrationInstructionsRounded from "@mui/icons-material/IntegrationInstructionsRounded";
import BuildSharp from "@mui/icons-material/BuildSharp";
import BuildCircleSharp from "@mui/icons-material/BuildCircleSharp";
import InterestsSharp from "@mui/icons-material/InterestsSharp";
import HealthAndSafety from "@mui/icons-material/HealthAndSafety";
import Watch from "@mui/icons-material/Watch";
import Kitchen from "@mui/icons-material/Kitchen";
import KitchenRounded from "@mui/icons-material/KitchenRounded";
import AttachMoney from "@mui/icons-material/AttachMoney";
import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import LocalShippingTwoTone from "@mui/icons-material/LocalShippingTwoTone";
import BuildCircle from "@mui/icons-material/BuildCircle";
import EventAvailable from "@mui/icons-material/EventAvailable";
import LocalDining from "@mui/icons-material/LocalDining";
import ArchiveRounded from "@mui/icons-material/ArchiveRounded";
import ArchiveOutlined from "@mui/icons-material/ArchiveOutlined";
import GavelSharp from "@mui/icons-material/GavelSharp";
import Pets from "@mui/icons-material/Pets";
import SportsKabaddiOutlined from "@mui/icons-material/SportsKabaddiOutlined";
import WifiCalling3 from "@mui/icons-material/WifiCalling3";
import TheaterComedySharp from "@mui/icons-material/TheaterComedySharp";
import SecurityUpdateGood from "@mui/icons-material/SecurityUpdateGood";
import PersonAddAltSharp from "@mui/icons-material/PersonAddAltSharp";
import Groups from "@mui/icons-material/Groups";
import RealEstateAgent from "@mui/icons-material/RealEstateAgent";
import ShieldMoonOutlined from "@mui/icons-material/ShieldMoonOutlined";
import QueuePlayNextRounded from "@mui/icons-material/QueuePlayNextRounded";
import TravelExplore from "@mui/icons-material/TravelExplore";
import PestControl from "@mui/icons-material/PestControl";
import RollerShadesClosedOutlined from "@mui/icons-material/RollerShadesClosedOutlined";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Print from "@mui/icons-material/Print";
import DirectionsCarFilled from "@mui/icons-material/DirectionsCarFilled";
import ReceiptOutlined from "@mui/icons-material/ReceiptOutlined";
import DirectionsCarFilledOutlined from "@mui/icons-material/DirectionsCarFilledOutlined";
import Inventory from "@mui/icons-material/Inventory";
import AttachMoneySharp from "@mui/icons-material/AttachMoneySharp";
import House from "@mui/icons-material/House";
import LocalOfferRounded from "@mui/icons-material/LocalOfferRounded";
import LocalOfferSharp from "@mui/icons-material/LocalOfferSharp";
import CampaignOutlined from "@mui/icons-material/CampaignOutlined";
import CleaningServices from "@mui/icons-material/CleaningServices";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import RecordVoiceOver from "@mui/icons-material/RecordVoiceOver";
import ContentCut from "@mui/icons-material/ContentCut";
import HotTub from "@mui/icons-material/HotTub";
import FaceRetouchingNatural from "@mui/icons-material/FaceRetouchingNatural";
import Palette from "@mui/icons-material/Palette";
import Insights from "@mui/icons-material/Insights";
import DesignServices from "@mui/icons-material/DesignServices";
import EmojiObjects from "@mui/icons-material/EmojiObjects";
import Devices from "@mui/icons-material/Devices";
import Business from "@mui/icons-material/Business";
import Language from "@mui/icons-material/Language";
import TrendingUp from "@mui/icons-material/TrendingUp";
import ContentPaste from "@mui/icons-material/ContentPaste";
import Analytics from "@mui/icons-material/Analytics";
import Favorite from "@mui/icons-material/Favorite";
import Celebration from "@mui/icons-material/Celebration";
import ElectricalServices from "@mui/icons-material/ElectricalServices";
import BusinessCenter from "@mui/icons-material/BusinessCenter";
import PermMedia from "@mui/icons-material/PermMedia";
import Person from "@mui/icons-material/Person";
import Store from "@mui/icons-material/Store";
import Landscape from "@mui/icons-material/Landscape";
import Nature from "@mui/icons-material/Nature";
import Power from "@mui/icons-material/Power";
import Grass from "@mui/icons-material/Grass";
import Agriculture from "@mui/icons-material/Agriculture";
import Water from "@mui/icons-material/Water";
import PhoneInTalk from "@mui/icons-material/PhoneInTalk";
import Accessible from "@mui/icons-material/Accessible";
import MedicalServices from "@mui/icons-material/MedicalServices";
import Science from "@mui/icons-material/Science";
import Psychology from "@mui/icons-material/Psychology";
import Male from "@mui/icons-material/Male";
import Plumbing from "@mui/icons-material/Plumbing";
import Build from "@mui/icons-material/Build";
import GridOn from "@mui/icons-material/GridOn";
import FormatPaint from "@mui/icons-material/FormatPaint";
import AcUnit from "@mui/icons-material/AcUnit";
import LocalLaundryService from "@mui/icons-material/LocalLaundryService";
import Tv from "@mui/icons-material/Tv";
import Computer from "@mui/icons-material/Computer";
import Weekend from "@mui/icons-material/Weekend";
import DeveloperBoard from "@mui/icons-material/DeveloperBoard";
import Settings from "@mui/icons-material/Settings";
import Diamond from "@mui/icons-material/Diamond";
import WaterDamage from "@mui/icons-material/WaterDamage";
import SoupKitchen from "@mui/icons-material/SoupKitchen";
import FamilyRestroom from "@mui/icons-material/FamilyRestroom";
import Description from "@mui/icons-material/Description";
import WorkOutline from "@mui/icons-material/WorkOutline";
import Handshake from "@mui/icons-material/Handshake";
import LocalShipping from "@mui/icons-material/LocalShipping";
import Storage from "@mui/icons-material/Storage";
import AccountBalance from "@mui/icons-material/AccountBalance";
import Moving from "@mui/icons-material/Moving";
import FlightTakeoff from "@mui/icons-material/FlightTakeoff";
import EditNote from "@mui/icons-material/EditNote";
import Translate from "@mui/icons-material/Translate";
import ContactSupport from "@mui/icons-material/ContactSupport";
import Hotel from "@mui/icons-material/Hotel";
import DriveEta from "@mui/icons-material/DriveEta";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import Image from "@mui/icons-material/Image";
import OpenInFull from "@mui/icons-material/OpenInFull";
import Movie from "@mui/icons-material/Movie";
import PhotoCameraFront from "@mui/icons-material/PhotoCameraFront";
import PhotoCameraBack from "@mui/icons-material/PhotoCameraBack";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CameraAlt from "@mui/icons-material/CameraAlt";
import PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import BrandingWatermark from "@mui/icons-material/BrandingWatermark";
import Article from "@mui/icons-material/Article";
import Category from "@mui/icons-material/Category";
import Fastfood from "@mui/icons-material/Fastfood";
import BreakfastDining from "@mui/icons-material/BreakfastDining";
import BugReport from "@mui/icons-material/BugReport";
import Bed from "@mui/icons-material/Bed";
import ConfirmationNumber from "@mui/icons-material/ConfirmationNumber";
import Place from "@mui/icons-material/Place";
import Public from "@mui/icons-material/Public";
import DeliveryDining from "@mui/icons-material/DeliveryDining";
import School from "@mui/icons-material/School";
import MenuBook from "@mui/icons-material/MenuBook";
import Smartphone from "@mui/icons-material/Smartphone";
import Router from "@mui/icons-material/Router";
import Satellite from "@mui/icons-material/Satellite";
import Spa from "@mui/icons-material/Spa";
import Videocam from "@mui/icons-material/Videocam";
import LocalFireDepartment from "@mui/icons-material/LocalFireDepartment";
import PersonSearch from "@mui/icons-material/PersonSearch";
import Lock from "@mui/icons-material/Lock";
import Stars from "@mui/icons-material/Stars";
import EventBusy from "@mui/icons-material/EventBusy";
import VolunteerActivism from "@mui/icons-material/VolunteerActivism";
import Checkroom from "@mui/icons-material/Checkroom";
import Memory from "@mui/icons-material/Memory";
import Bolt from "@mui/icons-material/Bolt";
import Calculate from "@mui/icons-material/Calculate";
import Lightbulb from "@mui/icons-material/Lightbulb";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import SelfImprovement from "@mui/icons-material/SelfImprovement";
import Cake from "@mui/icons-material/Cake";
import LocalBar from "@mui/icons-material/LocalBar";
import BakeryDining from "@mui/icons-material/BakeryDining";
import LocalCafe from "@mui/icons-material/LocalCafe";
import CelebrationTwoTone from "@mui/icons-material/CelebrationTwoTone";

import "./DealerList.css"
import ServiceCard from './ServiceCard';
import serviceData from './data';
import { sendEnquiryNotification } from '../services/emailService';
import { useForm, ValidationError } from '@formspree/react';
import "./DealerList"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Auth from '../pages/Auth';
import Dashboard from '../pages/Dashboard';
import PricingTable from './PricingTable';
import { FiPackage } from 'react-icons/fi';
import serviceImages from '../Assets/serviceImages';
import { AccountCircleOutlined, Apartment, Construction, EjectOutlined, HomeFilled, HomeMax } from '@mui/icons-material';
// import { House } from '@mui/icons-material';


const DealerList = () => {
  // Add these new states
  const [user, setUser] = useState(null);
  const [enquiries, setEnquiries] = useState([]);
  const [servicesData, setServicesData] = useState([]);
const [dealers, setDealers] = useState([]);

useEffect(() => {
  fetchServices();  // Still fetches category/services from services API
  fetchDealers();   // ✅ Fetch from MongoDB
}, []);
const iconMap = {
  '<MdHomeRepairService />': <HomeRepairService />,
  '<House />' :<HouseboatOutlined />,
  '<HomeWork />': <HomeWork />,
  '<DirectionsCar />': <DirectionsCar />,
  '<Campaign />':<Campaign />,
  '<Brush />' :<Brush />,
  '<Sparkles />':<AutoAwesome />,
   '<PencilLine />':<Edit />,
  '<MdDigitalMarketing />':<Campaign />,
  '<Gavel />':<Gavel />,
  '<TwoWheeler />': <TwoWheelerOutlined />,
  '<Build />': <BuildCircleOutlined />,
  '<EmojiEmotions />':<EmojiEmotions />, 
  '<ConstructionRounded />':<ConstructionRounded />,
  '<Computer />': <ComputerRounded />,
  '<CleanHandsOutlined />' : <CleanHandsOutlined />,
'<StarBorderOutlined />': <StarBorderPurple500Outlined />,
'<LocalOfferOutlined />' :<LocalOfferOutlined />,
'<ApartmentOutlined />' :<ApartmentOutlined />,
'<HouseOutlined />' :<HouseboatOutlined />,
'<CarRentalOutlined />':<CarRentalOutlined/>,
'<SupportAgentOutlined />':<SupportAgentOutlined />,
  '<Emergency />': <EmergencyOutlined />,
  '<Construction />': <ConstructionOutlined />,
  '<LocalShipping />' :<LocalShippingOutlined/>,
  '<Factory />' :<FactoryOutlined />,
  '<Receipt />':<ReceiptOutlined/>,
  '<FaShippingFast />':<DirectionsCarFilledOutlined />,
  '<FaBolt />':<FormatListBulletedOutlined />,
  '<MdGrass />':<NatureOutlined />,
  '<MdLocalFlorist />':<LocalFlorist />,
  '<FlashOnIcon />':<FlashOnOutlined/>,
   '<AccountBalanceWallet />':<AccountBalanceWalletRounded />,
   '<MdFitnessCenter />': <FitnessCenter />,
   '<MdHomeRepairService />':<HomeRepairService />,
   '<MdSettingsApplications />':<SettingsApplications />,
   '<MdOutlineChair />':<InterestsSharp/>,
   '<GiFactory />':<FactoryOutlined />,
   '<MdHealthAndSafety />':<HealthAndSafety />,
   '<GiWatch />':<Watch/>,
   '<GiKitchenKnives />':<Kitchen/>,
   '<MdKitchen />':<KitchenRounded />,
   '<MdAttachMoney />':<AttachMoneyOutlined />,
   '<DirectionsCarFilled />':<DirectionsCarFilled />,
   '<MdBuildCircle />':<BuildCircle/>,
   '<MdGavel />':<Gavel/>,
   '<MdEvent />':<EventAvailable />,
   '<LocalDining />':<LocalDining />,
   '<MdGavel />':<GavelSharp />,
   '<MdSupportAgent />':<SupportAgent />,
   '<MdPets />':<Pets />,
   '<MdWifiCalling3 />':<WifiCalling3 />,
   '<FaChalkboardTeacher />':<TheaterComedySharp/>,
   '<MdPersonSearch />':<PersonAddAltSharp />,
   '<MdSportsKabaddi />':<SportsKabaddiOutlined />,
   '<GiArchiveRegister />':<ArchiveOutlined/>,
   '<MdGroups />' :<Groups />,
   '<MdRealEstateAgent />':<RealEstateAgent />,
   '<FaPlaneDeparture />':<TravelExplore />,
   '<GiBugNet />':<PestControl />,
   '<FaPrint />':<Print />,
   '<TbRollerPaint />':<RollerShadesClosedOutlined />,
   '<MdOutlineReceiptLong />':<AttachMoneySharp />,
   '<MdPhotoCamera />':<PhotoCamera />,
   '<BiPackage />' :<Inventory />,
   '<RiShieldUserLine />':<ShieldMoonOutlined />,
   '<MdLocalHospital />' :<MedicationLiquidOutlined/>,
   '<MdPrecisionManufacturing />':<IntegrationInstructionsRounded />,
   '<Apartment />': <ApartmentOutlined />,
   '<Star />': <Star />,
   '<LocalOffer />': <LocalOfferRounded />,
   '<CleanHands />': <CleanHandsOutlined />,
   '<Tune />': <SettingsApplications />,
   '<CarRental />': <CarRentalOutlined />,
   '<SupportAgent />': <SupportAgentOutlined />,
   '<Campaign />': <CampaignOutlined />,

   '<MdCleaningServices />':<CleaningServices />,
   '<MdManageAccounts />':<ManageAccounts />,
   '<GiReceiveMoney />':<AttachMoney />,
   '<MdHomeWork />':<HomeWork />,
   '<LocalOffer />':<LocalOffer />,
   '<RecordVoiceOver />':<RecordVoiceOver />,
   '<ContentCut />':<ContentCut />,
   '<HotTub />':<HotTub />,
   '<FaceRetouchingNatural />':<FaceRetouchingNatural />,
   '<HealthAndBeauty />':<HealthAndSafety />,
   '<Palette />':<Palette />,
   '<Insights />':<Insights />,
   '<DesignServices />':<DesignServices />,
   '<EmojiObjects />':<EmojiObjects />,
   '<Devices />':<Devices />,
   '<HomeModern />':<Home />,
   '<BuildingOffice2 />':<Business />,
   '<MdSearch />':<Search />,
   '<MdOutlineManageAccounts />':<ManageAccounts />,
   '<MdWeb />':<Language />,
   '<MdTrendingUp />':<TrendingUp />,
   '<MdOutlineContentPaste />':<ContentPaste />,
   '<MdAnalytics />':<Analytics />,
   '<BsHeartFill />':<Favorite />,
   '<MdWork />':<Work />,
   '<MdCelebration />':<Celebration />,
   '<MdElectricalServices />':<ElectricalServices />,
   '<MdBusinessCenter />':<BusinessCenter />,
   '<MdFavorite />':<Favorite />,
   '<MdCelebration />':<Celebration />,
   '<MdBrush />':<Brush />,
   '<MdPermMedia />':<PermMedia />,
   '<MdPerson />':<Person />,
   '<MdBusiness />':<Business />,
   '<MdStoreMallDirectory />':<Store />,
   '<MdLandscape />':<Landscape />,
   '<MdNature />':<Nature />,
   '<MdPower />':<Power />,
   '<MdOutlineYard />':<Grass />,
   '<MdAgriculture />':<Agriculture />,
   '<MdLocalDining />':<LocalDining />,
   '<MdWater />':<Water />,
   '<MdPhoneInTalk />':<PhoneInTalk />,
   '<MdAccessible />':<Accessible />,
   '<MdMedicalServices />':<MedicalServices />,
   '<MdOutlineMedicalServices />':<MedicalServices />,
   '<MdScience />':<Science />,
   '<MdPsychology />':<Psychology />,
   '<MdMale />':<Male />,
   '<MdElectricalServices />':<ElectricalServices />,
   '<MdPlumbing />':<Plumbing />,
   '<MdCarpenter />':<Build />,
   '<MdGridOn />':<GridOn />,
   '<MdFormatPaint />':<FormatPaint />,
   '<MdAcUnit />':<AcUnit />,
   '<MdLocalLaundryService />':<LocalLaundryService />,
   '<MdTv />':<Tv />,
   '<MdComputer />':<Computer />,
   '<MdHotTub />':<HotTub />,
   '<MdOutlineSmartHome />':<HomeMax />,
   '<MdHome />':<Home />,
   '<MdBusiness />':<Business />,
   '<MdWeekend />':<Weekend />,
   '<GiProcessor />':<DeveloperBoard />,
   '<GiGears />':<Settings />,
   '<AttachMoney />':<AttachMoney />,
   '<AccountBalance />':<AccountBalance />,
   '<BusinessCenter />':<BusinessCenter />,
   '<GiDiamondRing />':<Diamond />,
   '<GiWatchPocket />':<Watch />,
   '<GiKitchenSink />':<Kitchen />,
   '<MdOutlineElectricalServices />':<ElectricalServices />,
   '<MdOutlineWaterDamage />':<WaterDamage />,
   '<GiCookingPot />':<SoupKitchen />,
   '<MdFamilyRestroom />':<FamilyRestroom />,
   '<MdBusinessCenter />':<BusinessCenter />,
   '<MdDescription />':<Description />,
   '<MdOutlineWork />':<WorkOutline />,
   '<MdHandshake />':<Handshake />,
   '<MdLocalShipping />':<LocalShipping />,
   '<MdStorage />':<Storage />,
   '<MdAccountBalance />':<AccountBalance />,
   '<MdMoving />':<Moving />,
   '<MdFlightTakeoff />':<FlightTakeoff />,
   '<MdWorkOutline />':<WorkOutline />,
   '<MdEditNote />':<EditNote />,
   '<MdTranslate />':<Translate />,
   '<MdOutlineContactSupport />':<ContactSupport />,
   '<MdComputer />':<Computer />,
   '<MdContentCut />':<ContentCut />,
   '<MdHotel />':<Hotel />,
   '<FaCarSide />':<DriveEta />,
   '<FaFilePdf />':<PictureAsPdf />,
   '<FaImage />':<Image />,
   '<FaExpandArrowsAlt />':<OpenInFull />,
   '<BiCameraMovie />':<Movie />,
   '<MdOutlinePhotoCameraFront />':<PhotoCameraFront />,
   '<MdOutlinePhotoCameraBack />':<PhotoCameraBack />,
   '<BiUserCircle />':<AccountCircleOutlined />,
   '<MdCameraAlt />':<CameraAlt />,
   '<MdPhotoLibrary />':<PhotoLibrary />,
   '<MdOutlineBrandingWatermark />':<BrandingWatermark />,
   '<HiDocumentReport />':<Article />,
   '<BiTrendingUp />':<TrendingUp />,
   '<TbHomePaint />':<HomeRepairService />,
   '<TbBuildingSkyscraper />':<Apartment />,
   '<TbSpray />':<Construction />,
   '<MdOutlineCategory />':<Category />,
   '<MdOutlineEco />':<EjectOutlined />,
   '<GiChicken />':<Fastfood />,
   '<MdOutlineEggAlt />':<BreakfastDining />,
   '<MdOutlineAgriculture />':<Agriculture />,
   '<GiInsectJaws />':<BugReport />, 
   '<GiTermite />':<PestControl />,
   '<GiBed />':<Bed />,
   '<FaTicketAlt />':<ConfirmationNumber />, 
   '<FaMapMarkedAlt />':<Place />,
   '<FaBuilding />':<Apartment />,
   '<FaGlobeAsia />':<Public />,
   '<FaTruckMoving />':<DeliveryDining />,
   '<FaTruckLoading />':<LocalShipping />,
   '<MdWorkOutline />':<WorkOutline />,
   '<FaUniversity />':<School />,
   '<FaBookReader />':<MenuBook />, 
   '<MdLanguage />':<Language />,
   '<FaUserTie />':<Work />,
   '<FaUserFriends />':<Groups />,
   '<FaBrain />':<Psychology />,
   '<MdSchool />':<School />,
   '<FaMobileAlt />':<Smartphone />,
   '<MdRouter />':<Router />,
   '<FaSatelliteDish />':<Satellite />,
   '<GiLotus />':<Spa />,
   '<MdOutlineVideocam />':<Videocam />,
   '<MdLocalFireDepartment />':<LocalFireDepartment />,
   '<RiUserSearchLine />':<PersonSearch />,
   '<HiOutlineLockClosed />':<Lock />,
   '<MdStars />':<Stars />,
   '<MdPalette />':<Palette />,
   '<MdFaceRetouchingNatural />':<FaceRetouchingNatural />,
   '<MdLocalLaundryService />':<LocalLaundryService />,
   '<MdEventBusy />':<EventBusy />,
   '<MdContentCut />':<ContentCut />,
   '<MdSpa />':<Spa />,
   '<MdFavorite />':<Favorite />,
   '<MdVolunteerActivism />':<VolunteerActivism />,
   '<MdBusiness />':<Business />,
   '<GiClothes />':<Checkroom />,
   '<GiChemicalDrop />':<Science />,
   '<MdMemory />':<Memory />,
   '<GiElectric />':<Bolt />,
   '<GiFoodTruck />':<Restaurant />,
   '<MdOutlineCalculate />':<Calculate />,
   '<GiExpense />':<AttachMoney />,
   '<GiJusticeStar />':<Gavel />,
   '<HiOutlineLightBulb />':<Lightbulb />,
   '<RiMoneyDollarCircleLine />':<MonetizationOn />,
   '<GiMeditation />':<SelfImprovement />,
   '<MdPsychology />':<Psychology />,
   '<MdOutlineMedicalServices />':<MedicalServices />,
   '<Cake />':<Cake />,
   '<LocalBar />':<LocalBar />,
   '<Restaurant />':<Restaurant />,
   '<BakeryDining />':<BakeryDining />,
   '<Fastfood />':<Fastfood />,
   '<LocalCafe />':<LocalCafe />,
   '<MdBusinessCenter />':<BusinessCenter />,
   '<MdManageAccounts />':<ManageAccounts />,
   '<MdEventAvailable />':<EventAvailable />,
   '<BookText />':<MenuBook />,
};

const fetchServices = async () => {
  try {
    const servicesRes = await fetch(`${process.env.REACT_APP_API_URL}/api/services`);
    const servicesData = await servicesRes.json();

    if (
      Array.isArray(servicesData) &&
      servicesData.length > 0 &&
      Array.isArray(servicesData[0].categories)
    ) {
      const categoriesRaw = servicesData[0].categories[0];

      const formattedServices = {};

      for (const categoryName in categoriesRaw) {
        const category = categoriesRaw[categoryName];
        formattedServices[categoryName] = {
          ...category,
          // 👇 map string to actual icon
          icon: iconMap[category.icon] || <LocalOffer />,
          services: category.services?.map(service => ({
            ...service,
            icon: iconMap[service.icon] || <LocalOffer />
          })) || [],
        };
      }

      setServicesData(formattedServices);
    } else {
      console.error('❌ Unexpected service API structure:', servicesData);
    }
  } catch (err) {
    console.error('❌ Failed to fetch services:', err);
  }
};



const fetchDealers = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dealers`);
    setDealers(res.data);
    console.log("✅ Fetched dealers from backend:", res.data);
  } catch (error) {
    console.error("❌ Failed to fetch dealers:", error);
  }
};


  // Add this effect to load enquiries from localStorage
useEffect(() => {
    const savedEnquiries = localStorage.getItem('enquiries');
    if (savedEnquiries) {
      setEnquiries(JSON.parse(savedEnquiries));
    }
  }, []);
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const theme = useTheme();
const { category } = useParams();
const navigate = useNavigate();

const categories = Object.keys(servicesData);

// Format: remove spaces, lowercase (e.g., "Real Estate" → "realestate")
const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '');

const activeTab = categories.findIndex(
  (cat) => formatCategory(cat) === category?.toLowerCase()
);

  // Add this function to calculate category stats
const getCategoryStats = (category) => {
  if (!servicesData[category]?.services) return { totalDealers: 0, totalEnquiries: 0, avgSatisfaction: 0 };
  
  const services = servicesData[category].services;
  
  const totalDealers = services.reduce((sum, service) => sum + (service.totalDealers || 0), 0);
  const totalEnquiries = services.reduce((sum, service) => sum + (service.totalEnquiries || 0), 0);
  
  // Calculate weighted average satisfaction
  const totalWeightedSatisfaction = services.reduce((sum, service) => {
    return sum + ((service.avgSatisfaction || 0) * (service.totalEnquiries || 1));
  }, 0);
  
  const totalWeight = services.reduce((sum, service) => sum + (service.totalEnquiries || 1), 0);
  const avgSatisfaction = totalWeight > 0 ? Math.round(totalWeightedSatisfaction / totalWeight) : 0;
  
  return { totalDealers, totalEnquiries, avgSatisfaction };
};

// Default to first tab if URL doesn't match
const safeTabIndex = activeTab === -1 ? 0 : activeTab;
  const [enquiryStep, setEnquiryStep] = useState(0);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedSubService, setSelectedSubService] = useState(null);
  const [formData, setFormData] = useState({});
  const [viewMode, setViewMode] = useState('categories');
  const [currentCategory, setCurrentCategory] = useState(null);
  const [currentService, setCurrentService] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: false,
    email: false,
    phone: false,
    details: false
  });
  const [state, handleSubmit] = useForm("mjkyqonk");
  const [selectedDealers, setSelectedDealers] = useState(null);
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^[0-9]{10,15}$/;
    return re.test(phone);
  };

  const startEnquiry = (category, service = null, subService = null, showDealers = false) => {
    setSelectedService(service);
    setSelectedSubService(subService);
    
    if (showDealers && subService) {
      setSelectedDealers(subService.dealers);
      setEnquiryStep(0); // Don't show enquiry form
      return; // Add this to prevent further execution
    }
    
    setEnquiryStep(service ? 1 : 0);
    setSelectedDealers(null);
    setFormData({
      category: category?.name || '',
      service: service?.name || '',
      subService: subService?.name || '',
      selectedDealer: null // Add this to track selected dealer
    });
    setFormErrors({
      name: false,
      email: false,
      phone: false,
      details: false
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateStep = (step) => {
    const errors = {};
    
    if (step === 1) {
      if (!formData.details) errors.details = true;
      if (!formData.name) errors.name = true;
      if (!formData.email || !validateEmail(formData.email)) errors.email = true;
      if (!formData.phone || !validatePhone(formData.phone)) errors.phone = true;
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(enquiryStep)) {
      setEnquiryStep(prev => prev + 1);
    }
  };

  const handleBack = () => setEnquiryStep(prev => prev - 1);

const submitEnquiry = async (e) => {
  e.preventDefault();

  if (!validateStep(1)) return;

  try {
    const newEnquiry = {
      service: selectedSubService ? selectedSubService.name : selectedService?.name || formData.category,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      details: formData.details,
      assignedDealer: formData.selectedDealerName || null,
      date: new Date().toISOString()
    };

    // 🌐 Send to backend instead of localStorage
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inquiries`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newEnquiry)
    });

    if (!response.ok) throw new Error('Failed to submit enquiry');

    alert(`Thank you ${formData.name}! Your enquiry has been submitted.`);

    setEnquiryStep(0);
    setFormData({});
    setSelectedDealers(null);
  } catch (err) {
    console.error('❌ Enquiry submission failed:', err);
    alert('Submission failed. Please try again.');
  }
};

  

 const showServiceDetail = (category, service, subService) => {
    setCurrentCategory(category);
    setCurrentService(service);
    setViewMode('service');
  };

  const backToCategories = () => {
    setViewMode('categories');
    setCurrentCategory(null);
    setCurrentService(null);
  };
  // Add this function to handle dealer assignment
const handleAssignDealer = (enquiryId, dealer) => {
    const updatedEnquiries = enquiries.map(enquiry => 
      enquiry.id === enquiryId 
        ? { 
            ...enquiry, 
            assignedDealer: dealer.name,
            status: 'Assigned',
            dealerId: dealer._id,
            dealerEmail: dealer.email,
            dealerPhone: dealer.phone
          } 
        : enquiry
    );
    setEnquiries(updatedEnquiries);
    localStorage.setItem('enquiries', JSON.stringify(updatedEnquiries));
  };

    // Add this function to handle enquiry status updates
  const handleEnquiryStatusChange = (enquiryId, newStatus) => {
    const updatedEnquiries = enquiries.map(enquiry => 
      enquiry.id === enquiryId 
        ? { ...enquiry, status: newStatus } 
        : enquiry
    );
    setEnquiries(updatedEnquiries);
    localStorage.setItem('enquiries', JSON.stringify(updatedEnquiries));
  };

  const DealersList = ({ dealers, onClose, onSelectDealer }) => {
    if (!user) {
    return <Auth onLogin={setUser} />;
  }

  if (user.isAdmin) {
    return <Dashboard
      user={user} 
      enquiries={enquiries} 
      onAssignDealer={handleAssignDealer} 
      dealers={dealers}
    />;
  }

  const handleFilterChange = (filter) => {
    setActiveFilter(activeFilter === filter ? null : filter);
  };

const getCurrentCategoryName = () => {
  const keys = Object.keys(servicesData);
  return keys.length > activeTab ? keys[activeTab] : '';
};

  const getCurrentCategoryColor = () => {
    const category = getCurrentCategoryName();
    return servicesData[category]?.color || theme.palette.primary.main;
  };


    return (
      <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Available Dealers</Typography>
            <IconButton onClick={onClose}>
              <ArrowBack />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {dealers.map((dealer) => (
              <Grid item xs={12} sm={6} key={dealer.id}>
                <Card>
                  <CardContent>
                    <Box display="flex" alignItems="center" mb={2}>
                      <Avatar sx={{ mr: 2 }}>
                        {dealer.name.charAt(0)}
                      </Avatar>
                      <Typography variant="h6">{dealer.name}</Typography>
                    </Box>
                    
                    <Box mb={2}>
                      <Typography variant="body2" color="text.secondary">
                        <Phone fontSize="small" sx={{ mr: 1 }} /> 
                        {dealer.phone}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        <Email fontSize="small" sx={{ mr: 1 }} />
                        {dealer.email}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        <LocationOn fontSize="small" sx={{ mr: 1 }} />
                        {dealer.location}
                      </Typography>
                    </Box>
                    
                    <Box display="flex" justifyContent="space-between">
                      <Rating value={dealer.rating} precision={0.5} readOnly />
                      <Chip 
                        label={`${dealer.enquiries} enquiries`}
                        size="small"
                        color="primary"
                      />
                    </Box>
  
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ mt: 2 }}
                      onClick={() => {
                        onSelectDealer(dealer);
                        onClose();
                      }}
                    >
                      Select This Dealer
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  const handleDealerSelect = (dealer) => {
    setFormData(prev => ({
      ...prev,
      selectedDealer: dealer.id,
      selectedDealerName: dealer.name
    }));
    setEnquiryStep(1); // Show enquiry form after selecting dealer
  };

  const categoryBanners = {
    'Real Estate': '/Banner/Real Estate.png',
    'Automotive': '/images/banner2.png',
    'Advertising and Marketing': '/Banner/Advertising.jpg',
    'Beauty & Wellness':'/Banner/Beauty & Wellness.jpg',
    'Branding':'/Banner/Branding.jpg',
    'Cleaning Services':'/Banner/Cleaning Services.jpg',
    'Digital Marketing':'/Banner/Digital Marketing.jpg',
    'Event Planning':'/Banner/Event Planning.jpg',
    'Kitchen Services':'/Banner/Kitchen Services.jpg',
    'Labour Law Compliance':'/Banner/Labour Law Compliance.jpg',
    'Legal Services':'/Banner/Legal Services.jpg',
    'Loans':'/Banner/Loans.jpg',
    'Logistics & Supply Chain (Expanded)':'/Banner/Logistics & Supply Chain (Expanded).jpg',
    'Manpower Needs':'/Banner/Manpower Needs.jpg',
    'Photography':'/Banner/Photography.jpeg',
    'Interior Design':'/Banner/Interior Design.jpg',
    'Food & Beverage':'/Banner/Food & Beverage.jpg',
    'Maintenance Services':'/Banner/Maintenance Services.jpg',
     'Payroll Services':'/Banner/Payroll Services.jpg',
     'Painting':'/Banner/Painting.jpg',
     'Poultry':'/Banner/Poultry.jpg',
     'Pest Control':'/Banner/Pest Control.jpg',
     'Travel':'/Banner/Travel.jpg',
     'Legal & Accounting':'/Banner/Legal & Accounting.jpg',
     'Organizations & Others':'/Banner/Organizations & Others.jpg',
     'Security & Investigation':'/Banner/Security & Investigation.jpg',
     'Personal Services':'/Banner/Personal Services.jpg',
     'Sports & Leisure':'/Banner/Sports & Leisure.jpg',
     'Telecommunications':'/Banner/Telecommunications.jpg',
     'Transport & Shipping':'/Banner/Transport & Shipping.jpg',
     'Home Repair & Maintenance':'/Banner/Home Repair & Maintenance.jpg',
     'Healthcare Services':'/Banner/Healthcare Services.jpg',
     'Home Appliance Repair':'/Banner/Home Appliance Repair.jpg',
     'Training & Coaching':'/Banner/Training & Coaching.jpg',
     'Manufacturing':'/Banner/Manufacturing.jpg',
     'Health & Wellness':'/Banner/Health & Wellness.jpg',
     'Polymers Packaging':'/Banner/Polymers Packaging.jpg',
     'Fitness & Training':'/Banner/Fitness & Training.jpg',
     'Gardening & Landscaping':'/Banner/Gardening & Landscaping.jpg',
     'Gardening Services':'/Banner/Gardening Services.jpg',
     'Jewelry & Watch Repair':'/Banner/Jewelry & Watch Repair.jpg',
     'Industrial & Manufacturing':'/Banner/Industrial & Manufacturing.jpg',
    'Moving & Relocation':'/Banner/Moving & Relocation.jpg',
    'Notary & Documentation':'/Banner/Notary & Documentation.jpg',
    'Office Support Services':'/Banner/Office Support Services.jpg',
    'Pet Care Services':'/Banner/Pet Care Services.jpg',
    'Printing Solutions':'/Banner/Printing Solutions.jpg',
    'Insurance':'/Banner/Insurance.jpg',
    'Cleaning Services':'/Banner/Cleaning Services.jpg',
    'Construction': '/images/construction-banner.jpg',
    'IT Services': '/images/it-services-banner.jpg',
    'Copywriter':'/Banner/CopywriterWriter.jpg',
    'Cleaning': '/images/cleaning-banner.jpg',
    'Legal': '/images/legal-banner.jpg',
    'Catering': '/images/banner4.png'
  };
    const categoryImages = {
    '🚗 Automotive Sales & Purchase Services': '/images/1.png',
    '🔧 Vehicle Maintenance & Repair Services': '/images/2.png',
    '🧼 Car Care & Detailing Services': '/images/3.png',
  };


  // Fallback banner if no image is specified
  const defaultBanner = '/images/default-banner.jpg';

  // Function to get current category name
const getCurrentCategoryName = () => {
  const keys = Object.keys(servicesData);
  return keys.length > activeTab ? keys[activeTab] : '';
};

  // Function to get current category color
  const getCurrentCategoryColor = () => {
    const category = getCurrentCategoryName();
    return servicesData[category]?.color || theme.palette.primary.main;
  };

  // Function to get current category banner
  const getCurrentCategoryBanner = () => {
    const category = getCurrentCategoryName();
    return categoryBanners[category] || defaultBanner;
  };
    const getCurrentCategory = () => {
    const category = getCurrentCategoryName();
    return categoryImages[category] ;
  };
const [activeFilter, setActiveFilter] = useState(null);
  const [sortOption, setSortOption] = useState('relevance');
  const [filteredServices, setFilteredServices] = useState({}); // Change to object
   // Add this effect to filter and sort services when filters change
  useEffect(() => {
    if (servicesData && Object.keys(servicesData).length > 0) {
      filterAndSortServices();
    }
  }, [servicesData, activeFilter, sortOption]);

const filterAndSortServices = () => {
    if (!servicesData || Object.keys(servicesData).length === 0) return;
    
    const updatedFilteredServices = {};
    
    // Process each category separately
    Object.keys(servicesData).forEach(category => {
      if (!servicesData[category]?.services) return;
      
      let filtered = [...servicesData[category].services];
      
      // Apply filters
      if (activeFilter === 'topRated') {
        filtered = filtered.filter(service => service.avgSatisfaction >= 80);
      } else if (activeFilter === 'quickResponses') {
        filtered = filtered.filter(service => service.avgResponseTime <= 24);
      } else if (activeFilter === 'propertiesServed') {
        filtered = filtered.filter(service => service.propertiesServed >= 50);
      }
      
      // Apply sorting
      if (sortOption === 'rating') {
        filtered.sort((a, b) => (b.avgSatisfaction || 0) - (a.avgSatisfaction || 0));
      } else if (sortOption === 'dealerCount') {
        filtered.sort((a, b) => (b.totalDealers || 0) - (a.totalDealers || 0));
      } else if (sortOption === 'enquiryCount') {
        filtered.sort((a, b) => (b.totalEnquiries || 0) - (a.totalEnquiries || 0));
      }
      
      updatedFilteredServices[category] = filtered;
    });
    
    setFilteredServices(updatedFilteredServices);
  };

const handleFilterChange = (filter) => {
  setActiveFilter(activeFilter === filter ? null : filter);
  // Add your filter logic here
};

return (
  <Box sx={{ p: 0, margin: '0 auto' }}>
    {!user ? (
      <Auth onLogin={setUser} />
    ) : user.isAdmin || user.isDealer ? (
      <Dashboard 
        user={user} 
        enquiries={enquiries} 
        onAssignDealer={handleAssignDealer}
        onEnquiryStatusChange={handleEnquiryStatusChange}
        dealers={dealers}
      />
    ) : (
      <>
        {/* ✅ My Dashboard button for logged-in normal user */}
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            alignItems: 'center',
            p: 2,
            backgroundColor: '#f9fafc',
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          <Button
            variant="contained"
            onClick={() => navigate('/user')}
            sx={{
              backgroundColor: '#4b698e',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#38536e' }
            }}
          >
            My Dashboard
          </Button>
        </Box>

      {viewMode === 'categories' ? (
        <>

<Box sx={{
          position: 'relative',
          height: 300,
          mb: 4,
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: 3
        }}>
          {/* Banner Image */}
          <Box
            component="img"
            src={getCurrentCategoryBanner()}
            alt={getCurrentCategoryName()}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: 'brightness(0.7)'
            }}
          />
          
          {/* Banner Overlay Content */}
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            // alignItems: 'center',
            color: 'white',
            textAlign: 'left',
            p: 3,
            background: `linear-gradient(to right, ${getCurrentCategoryColor()}80, ${getCurrentCategoryColor()}40)`
          }}>
            <Typography variant="h2" sx={{ 
              fontWeight: 700,
              mb: 2,
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
            }}>
              {getCurrentCategoryName()} 
            </Typography>
            <Typography variant="h5" sx={{
              maxWidth: 800,
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
            }}>
              Find trusted professionals for all your {(getCurrentCategoryName() || '').toLowerCase()} needs
            </Typography>
            
            <Button 
              variant="contained" 
              size="large"
              sx={{ 
                mt: 3,
                backgroundColor: 'white',
                color: getCurrentCategoryColor(),
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.9)'
                },
                width:'200px'
              }}
              onClick={() => startEnquiry({ name: getCurrentCategoryName() })}
            >
              Get a Free Quote
            </Button>
          </Box>
        </Box>
      
          <Typography variant="h4" gutterBottom sx={{ 
            fontWeight: 700,
            color: '#4b698e',
            mb: 4,
            display: 'flex',
            alignItems: 'center',
            // maxWidth:'1200px',
            gap: 2
          }}>
            <LocalOffer fontSize="large" /> Service Categories
          </Typography>

          <Paper sx={{ mb: 4, p: 2, borderRadius: 2, }}>
<Tabs 
  value={safeTabIndex}
  onChange={(e, newValue) => {
    const selectedCategory = categories[newValue];
    const formatted = formatCategory(selectedCategory);
    navigate(`/categories/${formatted}`);
  }}
  variant="scrollable"
  scrollButtons="auto"
  // sx={{
  //   '& .MuiTabs-indicator': {
  //     backgroundColor: Object.values(servicesData)[safeTabIndex]?.color || 'primary.main',
  //     height: 4,
  //     borderRadius: '0px 20px 0px 20px'
  //   }
  // }}
>
  {categories.map((category) => (
    <Tab 
      key={category}
      label={category}
      icon={servicesData[category]?.icon || <LocalOfferRounded />}
      iconPosition="start"
      sx={{ 
        minHeight: 64,
        '&.Mui-selected': {
          backgroundColor: `${servicesData[category]?.color || theme.palette.primary.main}20`,
          borderColor: `${servicesData[category]?.color || theme.palette.primary.main}20`,
          color: servicesData[category]?.color || theme.palette.primary.main,
          fontWeight: 'bold'
        },
        '&:hover': {
          backgroundColor: `${servicesData[category]?.color || theme.palette.primary.main}10`,
          borderColor: `${servicesData[category]?.color || theme.palette.primary.main}10`
        }
      }}
    />
  ))}
</Tabs>


</Paper>

          {Object.keys(servicesData).map((category, index) => (
            <Box key={category} sx={{ display: activeTab === index ? 'block' : 'none' }}>
              <Box sx={{ 
  display: 'flex', 
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 2,
  // maxWidth: '1200px',
  mb: 3
}}>
  {/* Title with icon */}
  <Typography variant="h5" sx={{ 
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    color: '#4b698e',
    mr: 2,
    // color: '${servicesData[category]?.color || theme.palette.primary.main}',
  }}>
    {servicesData?.[category]?.icon} {category} 
  </Typography>

  {/* Filter and Sort section */}
  <Box sx={{ 
    display: 'flex', 
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap'
  }}>
    {/* Quick filter chips */}
    <Box sx={{ display: 'flex', gap: 1 }}>
          {/* Sort dropdown */}
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel>Sort By</InputLabel>
      <Select
        value={sortOption}
        label="Sort By"
        onChange={(e) => setSortOption(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'divider'
          }
        }}
      >
        <MenuItem value="relevance">Relevance</MenuItem>
        <MenuItem value="rating">Highest Rating</MenuItem>
        <MenuItem value="dealerCount">Most Dealers</MenuItem>
        <MenuItem value="enquiryCount">Most Enquiries</MenuItem>
      </Select>
    </FormControl>
      <Chip
        label="Top Rated"
        variant="outlined"
        onClick={() => handleFilterChange('topRated')}
        sx={{
          borderColor: activeFilter === 'topRated' ? servicesData[category]?.color || theme.palette.primary.main : undefined,
          backgroundColor: activeFilter === 'topRated' ? `${servicesData[category]?.color || theme.palette.primary.main}10` : undefined
        }}
      />
            <Chip
        label="Quick Responses"
        variant="outlined"
        onClick={() => handleFilterChange('quickResponses')}
        sx={{
          borderColor: activeFilter === 'quickResponses' ? servicesData[category].color : undefined,
          backgroundColor: activeFilter === 'quickResponses' ? `${servicesData[category]?.color || theme.palette.primary.main}10` : undefined
        }}
      />
      <Chip
        label="Properties Served"
        variant="outlined"
        onClick={() => handleFilterChange('propertiesServed')}
        sx={{
          borderColor: activeFilter === 'propertiesServed' ? servicesData[category].color : undefined,
          backgroundColor: activeFilter === 'propertiesServed' ? `${servicesData[category]?.color || theme.palette.primary.main}10` : undefined
        }}
      />
    </Box>

    {/* Quick Enquiry button */}
    <Button 
      variant="contained" 
      startIcon={<Add />}
      onClick={() => startEnquiry({ name: category })}
      sx={{ 
        borderRadius: 2,
        backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
        '&:hover': {
          backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
          opacity: 0.9
        }
      }}
    >
      Quick Enquiry
    </Button>
  </Box>
</Box>
<Grid container spacing={3} sx={{
  backgroundColor:'#EDF0F5'}}>

              <Grid  item xs={12} md={6}>
              <Grid spacing={3}>
                {(filteredServices[category] || servicesData[category]?.services || []).map((service) => (
                  <Grid item xs={12} sm={6} md={4} key={service.id}>
                    <Card sx={{
                      borderLeft: `4px solid ${servicesData[category]?.color || theme.palette.primary.main}`,
                      // height: '380px',
                      display: 'flex',
                      // flexDirection: 'column',
                      // borderRadius: '12px',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                      // border: '1px solid #e0e0e0',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                      },
                      margin:'6px',
                    }}>
                      <CardMedia
  sx={{ width: '255px', height: 'auto', objectFit: 'cover', margin: 'auto', p: 2 }}
>
  <img
    src={serviceImages[service.id] || serviceImages.default}
    alt={service.name}
    style={{ width: '100%', height: '100%', borderRadius: '8px' }}
  />
</CardMedia>
 
                      <CardContent  xs={12} md={6} lg={6} sx={{
                        flexGrow: 1,
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        boxSizing: 'border-box'
                      }}>
                        <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, backgroundColor:"#797A7C", width:'fit-content', paddingLeft:'10px', paddingRight:'10px', color:'#fff', borderRadius:'10px', lineHeight:'2' }}>
                            {service.category || category}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, margin:'20px 0px 0px 0px' }}>
                            <Avatar sx={{
                              bgcolor: servicesData[category]?.color || theme.palette.primary.main,
                              color: 'white',
                              width: 40,
                              height: 40,
                              mr: 2
                            }}>
                              {service.icon}
                            </Avatar>
                            <Typography 
                              variant="subtitle1" 
                              fontWeight="600"
                              fontSize={'1.2rem'}
                              sx={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                lineHeight: '1.3',
                                width: '243px'
                                // minHeight: '2.6em'
                              }}
                            >
                              {service.name}
                            </Typography>
                          </Box>

                        </Box>

                        <Box sx={{ 
                          flex: '1 1 auto',
                          minHeight: 0,
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column'
                        }}>
                          <Box sx={{
                            display: 'flex',
                            // justifyContent: 'space-between',
                            mb: 1,
                            gap: 2
                          }}>
                            <Box sx={{ textAlign: 'center', bgcolor: servicesData[category]?.color || theme.palette.primary.main, display:'flex', alignItems:'center', gap:'5px', padding:'2px 10px', borderRadius:'10px', color:'#fff' }}>
                              <Typography variant="caption" fontWeight="bold" fontSize={'14px'}>
                                {service.totalDealers || 0}
                              </Typography>
                              <Typography variant="caption" color="#fff" fontSize={'14px'}>
                                Dealers
                              </Typography>
                            </Box>
                            <Box sx={{ textAlign: 'center', backgroundColor: '#4D4D4D', display:'flex', alignItems:'center', gap:'5px', padding:'2px 10px', borderRadius:'10px', color:'#fff' }}>
                              <Typography variant="caption" fontWeight="bold" fontSize={'14px'}>
                                {service.totalEnquiries || 0}
                              </Typography>
                              <Typography variant="caption" color="#fff" fontSize={'14px'}>
                                Enquiries
                              </Typography>
                            </Box>
                          </Box>

                          <Box sx={{ mb: 1, backgroundColor:'#F1F1F1', padding:'10px'  }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5}}>
                              <Typography variant="caption" color="text.secondary" fontSize={'17px'}>
                                Satisfaction
                              </Typography>
                              <Typography variant="caption" fontWeight="bold" color={servicesData[category]?.color || theme.palette.primary.main}>
                                {service.avgSatisfaction || 0}%
                              </Typography>
                            </Box>
                            <LinearProgress
                              variant="determinate"
                              value={service.avgSatisfaction || 0}
                              sx={{
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                '& .MuiLinearProgress-bar': {
                                  borderRadius: 3,
                                  backgroundColor: servicesData[category]?.color || theme.palette.primary.main
                                }
                              }}
                            />
                          </Box>
                          {service.topDealers && service.topDealers.length > 0 && (
                            <Box sx={{ 
                              flex: '1 1 auto',
                              overflow: 'hidden',
                              mb: 1
                            }}>
                              <Typography variant="caption" fontWeight="medium" display="block" gutterBottom>
                                TOP DEALERS
                              </Typography>
                              <Box sx={{ 
                                maxHeight: '120px',
                                overflowY: 'auto',
                                pr: 1,
                                '&::-webkit-scrollbar': {
                                  width: '4px'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#ddd',
                                  borderRadius: '2px'
                                }
                              }}>
                                {service.topDealers.slice(0, 3).map((dealer) => (
                                  <Box
                                    key={dealer.id}
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1,
                                      py: 1,
                                      px: 1.5,
                                      backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                      borderRadius: '6px'
                                    }}
                                  >
                                    <Typography variant="body2" noWrap sx={{ flex: 1, mr: 1 }}>
                                      {dealer.name}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                      <Chip
                                        label={`${dealer.enquiries}`}
                                        size="small"
                                        sx={{ 
                                          borderRadius: '4px',
                                          backgroundColor: 'transparent',
                                          border: '1px solid #e0e0e0'
                                        }}
                                      />
                                      <Rating
                                        value={dealer.rating}
                                        precision={0.5}
                                        readOnly
                                        size="small"
                                        sx={{ ml: 1, '& .MuiRating-icon': { fontSize: '16px' } }}
                                      />
                                    </Box>
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>

                        <Box sx={{ mt: 'auto', pt: 2 }}>
                          <Button
                            variant="outlined"
                            size="large"
                            onClick={() => showServiceDetail(
                              { name: category, color: servicesData[category]?.color || theme.palette.primary.main },
                              service
                            )}
                            sx={{
                              // borderColor: servicesData[category].color,
                              // color: servicesData[category].color,
                              backgroundColor: '#4D4D4D', borderRadius:'10px', color:'#fff' ,
                              '&:hover': {
                                backgroundColor: `${servicesData[category]?.color || theme.palette.primary.main}10`,
                                borderColor: servicesData[category]?.color || theme.palette.primary.main,
                                color:`${servicesData[category]?.color || theme.palette.primary.main}`
                              }
                            }}
                          >
                            View Details
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              </Grid>
              
              <Grid item xs={12} md={6} sx={{ margin:'6px', width:'45%'}}>
              <Grid container spacing={1} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <Card >
                    <CardContent sx={{width: 'auto'}}>
                      <Typography variant="caption" color="text.secondary" fontSize={'17px'}>
                        Total<br /> Dealers
                      </Typography>
                      <Typography 
  variant="h5"
  sx={{ 
    position: 'relative',
    textAlign:'right',
    paddingLeft: 10, // space for the border
    fontSize:'1.5rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: '60%', // adjust this value to control border height
      width: '5px',
      backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
    }
  }}
>
  {getCategoryStats(category).totalDealers}
</Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card>
                    <CardContent sx={{width: '117px'}}>
                      <Typography variant="caption" color="text.secondary"  fontSize={'17px'}>
                        Total<br /> Enquiries
                      </Typography>
                      <Typography 
  variant="h5"
  sx={{ 
    position: 'relative',
    paddingLeft: 8, // space for the border
    textAlign:'right',
     fontSize:'1.5rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: '60%', // adjust this value to control border height
      width: '5px',
      backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
    }
  }}>
                        {getCategoryStats(category).totalEnquiries}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card>
                    <CardContent sx={{width: 'auto'}}>
                      <Typography variant="caption" color="text.secondary"  fontSize={'17px'}>
                        Satisfaction
                      </Typography>
                      <Box sx={{ display: 'block', alignItems: 'center' }}>
                      <Rating value={getCategoryStats(category).avgSatisfaction / 20} precision={0.1} readOnly   sx={{
    fontSize: '1.35rem', // Adjust the size as needed
    '& .MuiRating-icon': {
      fontSize: 'inherit' // Ensures icons inherit the size
    }
  }} />
                        <Typography 
  variant="h5"
  sx={{ 
    position: 'relative',
    paddingLeft: 8, // space for the border
    textAlign:'right',
     fontSize:'1.5rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: '60%', // adjust this value to control border height
      width: '5px',
      backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
    }
  }}>
                          {getCategoryStats(category).avgSatisfaction}%
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Card>
                    <CardContent sx={{width: 'auto'}}>
                      <Typography variant="caption" color="text.secondary"  fontSize={'17px'}>
                        Service <br />Types
                      </Typography>
                      <Typography 
  variant="h5"
  sx={{ 
    position: 'relative',
    paddingLeft: 10, // space for the border
    textAlign:'right',
     fontSize:'1.5rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: '60%', // adjust this value to control border height
      width: '5px',
      backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
    }
  }}>
                        {filteredServices[category].length}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
  {/* Find the Best Provider Section */}
  <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
    <Typography variant="h5" sx={{ 
      fontWeight: 600,
      mb: 3,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      color: servicesData[category]?.color || theme.palette.primary.main
    }}>
      <Work fontSize="medium" /> Find the Best {category} Services
    </Typography>
    
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }}>
      {(filteredServices[category] || servicesData[category]?.services || []).slice(0, 4).map((service, index) => (
        <Box key={index} sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          borderRadius: 1,
          backgroundColor: '#f9f9f9',
          '&:hover': {
            backgroundColor: '#f0f0f0',
            cursor: 'pointer'
          }
        }}>
          <Avatar sx={{ 
            bgcolor: `${servicesData[category]?.color || theme.palette.primary.main}20`,
            color: servicesData[category]?.color || theme.palette.primary.main,
            width: 40,
            height: 40
          }}>
            {iconMap[service?.icon]
    ? React.createElement(iconMap[servicesData[category]?.icon])
    : <LocalOfferRounded />}
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" fontWeight="500" fontSize={'23px'}>
              {service.name || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary" fontSize={'20px'}>
              {service.totalDealers || 0} verified providers
            </Typography>
          </Box>
          <Rating 
            value={(service.avgSatisfaction || 0) / 20}
            precision={0.5} 
            readOnly 
            size="large"
          />
        </Box>
      ))}
    </Box>
    
    <Button 
      fullWidth 
      variant="contained" 
      sx={{ 
        mt: 3,
        backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
        '&:hover': {
          backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
          opacity: 0.9
        }
      }}
      onClick={() => startEnquiry({ name: category })}
    >
      View All Services
    </Button>
  </Card>

  {/* Popular Searches Slider */}
  <Card sx={{ p: 3, boxShadow: 3 }}>
    <Typography variant="h5" sx={{ 
      fontWeight: 600,
      mb: 3,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      color: servicesData[category]?.color || theme.palette.primary.main
    }}>
      <Search fontSize="medium" /> Popular Searches
    </Typography>
    
    <Box sx={{ width: '100%' }}>
      <Slider
        // dots={true}
        infinite={true}
        speed={500}
        slidesToShow={2}
        slidesToScroll={1}
        arrows={false}
        responsive={[
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
      >
        {servicesData[category]?.popularSearches?.map((search, index) => (
          <Box key={index} sx={{ px: 1 }}>
            <Card className="popular-search-card">
              <Box sx={{ 
                width: 'auto',
                height: '150px',
                borderRadius: '50%',
                backgroundColor: `${servicesData[category]?.color || theme.palette.primary.main}20`,
                display: 'flex',
                // alignItems: 'center',
                // justifyContent: 'center',
                margin: '0 auto 15px',
                color: servicesData[category]?.color || theme.palette.primary.main
              }}>
                <img src={search.image} />
              </Box>
              <Typography variant="subtitle1" fontWeight="500">
                {search.term}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {search.count} searches
              </Typography>
            </Card>
          </Box>
        ))}
      </Slider>
    </Box>
  </Card>
</Grid>
              </Grid>
              </Grid>
            </Box>
          ))}
        </>
      ) : (
        
        <Box sx={{bgcolor: "#EDF0F5"}}>
          
          <Button 
            startIcon={<ArrowBack />}
            onClick={backToCategories}
            sx={{ mb: 3 }}
          >
            Back to Categories
          </Button>
          <Breadcrumbs sx={{ mb: 3 }}>
            <Link color="inherit" onClick={backToCategories}>
              Categories
            </Link>
            <Typography color="text.primary">
              {currentCategory.name} 
            </Typography>
          </Breadcrumbs>
          
          <Paper sx={{ p: 0, mb: 3, display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
      {/* Left Side - Banner Image with Title */}
      <Box
  sx={{
    width: { xs: '100%', md: '40%' },
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${serviceImages[currentService.id] || serviceImages.default})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    minHeight: 200,
    display: 'flex',
    alignItems: 'flex-end',
    p: 3,
    color: '#fff',
  }}
>

        <Box sx={{ zIndex: 1 }}>
          <Typography variant="h3" sx={{ 
            fontWeight: 600,
            color: 'white',
            mb: 1
          }}>
            {currentService.name}
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            {currentCategory.name} 
          </Typography>
        </Box>
      </Box>

      {/* Right Side - Stats */}
      <Box sx={{ 
        width: { xs: '100%', md: '60%' },
        p: 3
      }}>
<Grid container spacing={1} sx={{ mb: 4 }}>
  <Grid item xs={12} sm={6} md={3}>
    <Card>
      <CardContent sx={{width: '130px'}}>
        <Typography variant="caption" color="text.secondary" fontSize={'17px'}>
          Total<br /> Dealers
        </Typography>
        <Typography 
          variant="h5"
          sx={{ 
            position: 'relative',
            textAlign:'right',
            paddingLeft: 3,
            fontSize:'36px',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              height: '60%',
              width: '5px',
              backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
            }
          }}
        >
          {currentService.totalDealers}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
    <Card>
      <CardContent sx={{width: '130px'}}>
        <Typography variant="caption" color="text.secondary" fontSize={'17px'}>
          Total<br /> Enquiries
        </Typography>
        <Typography 
          variant="h5"
          sx={{ 
            position: 'relative',
            paddingLeft: 3,
            textAlign:'right',
            fontSize:'36px',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              height: '60%',
              width: '5px',
              backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
            }
          }}
        >
          {currentService.totalEnquiries}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
    <Card>
      <CardContent sx={{width: '130px'}}>
        <Typography variant="caption" color="text.secondary" fontSize={'17px'}>
          Satisfaction
        </Typography>
        <Box sx={{ display: 'block', alignItems: 'center' }}>
          <Rating 
            value={currentService.avgSatisfaction / 20} 
            precision={0.1} 
            readOnly   
            sx={{
              fontSize: '1.40rem',
              '& .MuiRating-icon': {
                fontSize: 'inherit'
              }
            }} 
          />
          <Typography 
            variant="h5"
            sx={{ 
              position: 'relative',
              paddingLeft: 3,
              textAlign:'right',
              fontSize:'36px',
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '60%',
                width: '5px',
                backgroundColor: servicesData[category]?.color || theme.palette.primary.main,
              }
            }}
          >
            {currentService.avgSatisfaction}%
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
     <Card
      // sx={{
      //   borderRadius: 3,
      //   boxShadow: 3,
      //   transition: '0.3s ease',
      //   '&:hover': { boxShadow: 6, transform: 'translateY(-3px)' },
      //   m: { xs: 1, sm: 2 },
      // }}
    >
      <CardContent
        sx={{
          // p: { xs: 2, sm: 2.5 },
          // display: 'flex',
          // flexDirection: 'column',
          // justifyContent: 'center',
          // alignItems: 'flex-start',
          // height: '100%',
          width: '130px'
        }}
      >
        {/* Label */}
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{
            fontSize: { xs: '14px', sm: '15px' },
            mb: 0.5,
            fontWeight: 500,
          }}
        >
          Service <br /> Types
        </Typography>

        {/* Number Display */}
        <Box sx={{ position: 'relative', width: '100%', textAlign: 'right' }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '30px', sm: '36px', md: '42px' },
              color: theme.palette.text.primary,
              lineHeight: 1.1,
              paddingLeft: 3,
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '60%',
                width: '5px',
                borderRadius: '4px',
                backgroundColor:
                  servicesData[category]?.color || theme.palette.primary.main,
              },
            }}
          >
            {currentService?.subServices?.length || 0}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Grid>
</Grid>
        
        <Divider sx={{ my: 2 }} />
        
        <Button 
          variant="contained" 
          size="large"
          onClick={() => startEnquiry(currentCategory, currentService)}
          sx={{ 
            mt: 2,
            backgroundColor: currentCategory.color,
            float: 'right',
            '&:hover': {
              backgroundColor: currentCategory.color,
              opacity: 0.9
            }
          }}
        >
          Enquire About This Service
        </Button>
      </Box>
    </Paper>
          
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Sub-Services
          </Typography>
          
          <Grid container spacing={3}>
            {currentService.subServices.map((subService, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card sx={{ 
                  // borderLeft: `4px solid ${serviceData[currentCategory.name].color}`,
                  '&:hover': {
                    boxShadow: 2
                  }
                }}>
                  <CardContent sx={{width:'width: 250px;'}}>
                    <Box sx={{ mb: 2 }}>
                      <img src={subService.image} style={{width: '250px'}}/>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{width: '350px',height:'60px', fontSize:'21px', display:'flex', justifyContent:'space-between'}}>
                        {subService.name}
                        {subService.popular && (
                          <Chip 
                            label="Popular" 
                            // size="small" 
                            color="primary"
                            sx={{ ml: 1 , fontSize:'x-small', padding:'1px'}}
                          />
                        )}
                      </Typography>
                    </Box>
                    
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      {subService.dealers.length} verified dealers available
                    </Typography>
                    
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button 
                        variant="outlined"
                        sx={{bgcolor: '#4D4D4D', color: "#fff", textTransform:'capitalize'}}
                        onClick={() => {
                          setSelectedSubService(subService);
                          setEnquiryStep(1);
                        }}
                      >
                        Quick Enquire
                      </Button>
                      <Button 
                        variant="contained"
                        sx={{bgcolor: servicesData[currentCategory.name].color, textTransform:'capitalize'}}
                        onClick={() => {
                          startEnquiry(
                            currentCategory,
                            currentService,
                            subService,
                            true // Set showDealers flag to true
                          );
                        }}
                      >
                        View Dealers
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
{selectedDealers && (
  <DealersList 
    dealers={selectedDealers} 
    onClose={() => setSelectedDealers(null)}
    onSelectDealer={handleDealerSelect}
  />
)}
<Dialog 
  open={enquiryStep > 0} 
  onClose={() => setEnquiryStep(0)}
  fullWidth
  maxWidth="sm"
>
{selectedSubService?.image && (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
      <img 
        src={selectedSubService.image} 
        alt={selectedSubService.name} 
        style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
      />
    </Box>
  )}
  {currentService === "tax" ? <PricingTable /> : ""}

  <form onSubmit={submitEnquiry}>
    <DialogTitle sx={{ borderBottom: '1px solid rgba(0,0,0,0.12)', color: servicesData.color}}>
      <Typography variant="h6" align="center">
        {selectedSubService ? selectedSubService.name : selectedService ? selectedService.name : formData.category} Enquiry
      </Typography>
    </DialogTitle>

    <DialogContent dividers sx={{ pt: 3 }}>
          <Box>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Please provide your contact information and enquiry details:
            </Typography>
            

                <TextField
                  fullWidth
                  label="Full Name"
                  name="name"
                  value={formData.name || ''}
                  onChange={handleInputChange}
                  error={formErrors.name}
                  helperText={formErrors.name ? "Please enter your name" : ""}
                  required
                  sx={{mb:2}}
                />

                <TextField
                  fullWidth
                  label="Email Address"
                  type="email"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleInputChange}
                  error={formErrors.email}
                  helperText={formErrors.email ? "Please enter a valid email" : ""}
                  required
                  sx={{mb:2}}

                />

                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phone"
                  value={formData.phone || ''}
                  onChange={handleInputChange}
                  error={formErrors.phone}
                  helperText={formErrors.phone ? "Please enter a valid phone number" : ""}
                  required
                  sx={{mb:2}}

                />

                <TextField
                  fullWidth
                  label="Company Name (Optional)"
                  name="company"
                  value={formData.company || ''}
                  onChange={handleInputChange}
                  sx={{mb:2}}

                />


            <TextField
              fullWidth
              multiline
              rows={4}
              label="Enquiry Details"
              name="details"
              value={formData.details || ''}
              onChange={handleInputChange}
              error={formErrors.details}
              helperText={formErrors.details ? "Please provide some details" : ""}
              required
              sx={{ mb: 2 }}
            />
            
            {selectedSubService && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                You're enquiring about: <strong>{selectedSubService.name}</strong>
              </Typography>
            )}

            <Box sx={{ 
              mt: 2,
              p: 2,
              bgcolor: 'background.paper',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider'
            }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Your Enquiry Summary:
              </Typography>
              <Typography variant="body2">
                <strong>Service:</strong> {formData.subService || formData.service || formData.category}
              </Typography>
            </Box>
          </Box>
          </DialogContent>

<DialogActions sx={{ 
  p: 2,
  borderTop: '1px solid rgba(0,0,0,0.12)',
  justifyContent: 'space-between'
}}>
  <Button 
    onClick={() => setEnquiryStep(0)}
    startIcon={<ArrowBack />}
  >
    Cancel
  </Button>
  
  <Button 
    type="submit"
    variant="contained" 
    color="success"
    startIcon={<CheckCircle />}
    disabled={
      !formData.name || 
      !formData.email || 
      !formData.phone ||
      !formData.details ||
      formErrors.name ||
      formErrors.email ||
      formErrors.phone ||
      formErrors.details ||
      state.submitting
    }
  >
    {state.submitting ? 'Submitting...' : 'Submit Enquiry'}
  </Button>
</DialogActions>
</form>
</Dialog>
</>
      )}
    </Box>
  );
};

export default DealerList;